<div class="header">
  <div class="title">Mark Deal Acquired</div>
  <button class="close-button" mat-icon-button (click)="discard()" [tabIndex]="-1">
    <mat-icon [svgIcon]="'close'"></mat-icon>
  </button>
</div>
<form [formGroup]="projectForm">
  <!-- Subject -->
  <div class="flex flex-col gt-xs:flex-row mt-3">
    <mat-form-field class="subject flex-auto">
      <mat-label>Sale Price</mat-label>
      <input matInput [formControlName]="'sale_price'" currencyMask [options]="currencyMaskOptions" />
    </mat-form-field>
  </div>
  <div class="flex flex-col gt-xs:flex-row mt-3">
    <mat-form-field class="flex-auto gt-xs:pr-3">
      <mat-label>Status</mat-label>
      <mat-select [formControlName]="'project_stage_id'">
        <mat-option *ngFor="let projectStage of projectStages" [value]="projectStage.id">
          {{ projectStage.name }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  <div class="flex flex-col gt-xs:flex-row mt-3">
    <mat-form-field class="treo-mat-textarea treo-mat-no-subscript flex-auto gt-xs:pr-3">
      <mat-label>Notes</mat-label>
      <textarea matInput treoAutogrow [formControlName]="'comment'" [spellcheck]="false"></textarea>
    </mat-form-field>
  </div>

  <!-- Body -->

  <div class="actions">
    <div class="formatting"></div>

    <div class="buttons">
      <!-- Discard -->
      <button class="discard-button" mat-button type="button" (click)="discard()">
        <span>Cancel</span>
      </button>

      <!-- Send -->
      <button
        class="send-button"
        mat-flat-button
        [color]="'primary'"
        type="submit"
        [disabled]="projectForm.invalid"
        (click)="save()"
      >
        <span *ngIf="!projectForm.disabled">Save</span>
        <mat-progress-spinner
          *ngIf="projectForm.disabled"
          [diameter]="24"
          [mode]="'indeterminate'"
        ></mat-progress-spinner>
      </button>
    </div>
  </div>
</form>
